const styles = theme => ({
  portrait: {},
  landscape: {},
  isFullscreen: {
    '& $speedDial': {
      marginRight: theme.spacing(3)
    }
  },
  donateButtons: {
    '&:focus': {
      outline: 'white solid 4px'
    },
    padding: theme.spacing(4.5, 0),
    width: '100%',
    '@media (max-width: 1024px)': {
      padding: theme.spacing(2)
    },
    '&$portrait': {
      '@media (max-width: 767px)': {
        '& $donateOption': {
          padding: 0,
          minWidth: 'initial'
        },
        '& $blueBox': {
          top: 0
        },
        '& $form': {
          flexDirection: 'column'
        },
        '& $confirmText': {
          marginBottom: theme.spacing(2),
          textAlign: 'center'
        }
      }
    }
  },
  donateButtonsBox: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 1,
    '@media (min-width: 1023px)': {
      paddingRight: theme.spacing(2)
    }
  },
  compactDonateButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  speedDialButton: {
    margin: '0',
    padding: '0 24px',
    boxShadow: [
      '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
      '!important'
    ],
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  buttons: {
    '@media (max-width: 1024px)': {
      flexDirection: 'column'
    },
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  button: {
    '@media (max-width: 1024px)': {
      flexDirection: 'column'
    },
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  amountButtons: {
    '@media (max-width: 1024px)': {
      display: 'flex',
      marginBottom: theme.spacing(2),
      '& $donateOption': {
        flexGrow: 1
      },
      '&:focus': {
        outline: 'white solid 2px'
      }
    }
  },
  donateWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 1
  },
  donateOption: {
    flexGrow: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    '&:focus': {
      outline: 'white solid 2px'
    }
  },
  howToDonate: {
    color: 'white',
    fontFamily: 'Poppins',
    fontSize: 20,
    transition: 'filter 800ms ease-in-out'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    top: 6,
    marginRight: theme.spacing(2)
  },
  inputRoot: {
    color: 'white'
  },
  inputUnderline: {
    '&:before': {
      borderColor: ['white', '!important']
    },
    '&:after': {
      borderColor: ['white', '!important']
    }
  },
  formHelperError: {
    color: ['white', '!important']
  },
  blueBox: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'all',
    zIndex: 2
  },
  confirmText: {
    fontSize: '1.55rem',
    marginRight: theme.spacing(2),
    lineHeight: '1.6rem'
  },
  confirmButton: {
    background: 'white',
    color: theme.palette.secondary.main,
    borderRadius: '20px',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    padding: '6px 36px',
    height: '42px',
    margin: '10px',
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  closeConfirmButton: {
    position: 'absolute',
    right: theme.spacing(),
    top: theme.spacing(),
    color: 'white',
    '&:focus': {
      outline: 'white solid 4px'
    }
  },
  speedDial: {},
  tooltip: {
    display: ['none', '!important']
  },
  hiddenTextField: {
    height: 0,
    width: 0,
    color: 'transparent'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/DonateButtons/styles.js